import { BasicRequest } from "./basicRequest";

export class DeleteMoovInstanceRequest extends BasicRequest{
    public moovInstanceId!:number;

    constructor(){
        super();
    }
}